import styled from 'styled-components'

export const SettingsContainer = styled.div`
    position: absolute;
    width: 300px;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content:center;
    align-items: stretch;
    border-radius: 30px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    background-color: ${props => props.theme.fifth};
    top: 50px;
    right: 60px;
    z-index: 10;

    p {
        font-size: 1.5rem;
        color:${props => props.theme.third};
        margin-right: 15px;
    }

    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #2196F3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }
`
export const XDiv = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    svg {
        margin-right: 20px;
    }
`

export const ButtonsDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

